import { render, staticRenderFns } from "./DelegateExternalForm.vue?vue&type=template&id=8aa51326&"
import script from "./DelegateExternalForm.vue?vue&type=script&lang=js&"
export * from "./DelegateExternalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports